import { Reveal, SectionHeading } from "./Reveal";
import { Link2, BrainCircuit, Eye, Rocket } from "lucide-react";

const STEPS = [
  {
    icon: Link2,
    title: "Drop your Google Business link",
    body: "Paste your Google Business Profile link and a few contact details. That's all we need from you.",
  },
  {
    icon: BrainCircuit,
    title: "AI synthesizes site & voice persona",
    body: "Our engine reads your reviews, photos, services and tone — then drafts your website and trains your voice agent.",
  },
  {
    icon: Eye,
    title: "Preview your live draft",
    body: "Within 48 hours you get a working preview of your site and a test number to call your AI agent. Free. No card.",
  },
  {
    icon: Rocket,
    title: "Launch & capture revenue",
    body: "Approve, go live, and watch bookings land on your calendar while the AI answers every single call.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="relative py-24 md:py-36 px-4 sm:px-6 lg:px-8 bg-[#0A0D14]/50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          testId="how-it-works-heading"
          kicker="The process"
          title="Live in four steps"
          sub="From a single link to a fully staffed digital front desk."
        />
        <div className="mt-16 relative">
          <div className="absolute left-[27px] lg:left-0 lg:top-[27px] lg:h-px lg:w-full h-full w-px bg-gradient-to-b lg:bg-gradient-to-r from-cyan-400/50 via-violet-500/40 to-transparent" />
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.15}>
                <div data-testid={`how-it-works-step-${i + 1}`} className="relative pl-20 lg:pl-0 lg:pt-20 group">
                  <div className="absolute left-0 lg:top-0 flex h-14 w-14 items-center justify-center rounded-2xl border border-cyan-400/40 bg-[#0D111A] shadow-[0_0_28px_rgba(0,240,255,0.18)] group-hover:shadow-[0_0_44px_rgba(0,240,255,0.35)] group-hover:border-cyan-300/70 transition-[box-shadow,border-color] duration-500">
                    <s.icon className="h-6 w-6 text-cyan-300" />
                  </div>
                  <span className="font-mono text-xs font-semibold tracking-[0.3em] text-cyan-400/70">
                    STEP {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-3 font-display text-lg sm:text-xl font-semibold tracking-tight text-slate-50">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
